<script lang="ts">

    export let name: string;
</script>
<svg class="svg-icon {$$restProps.class}"> <use xlink:href="#{name}"></use></svg>
